export default {
  container: {
    mt: '1rem',
  },
  spinnerContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  },
  grid: {
    gridTemplateColumns: ['repeat(1, 1fr)', null, null, null, 'repeat(2, 1fr)'],
  },
  panelContainer: {
    flexDirection: 'column',
    height: '70vh',
    flex: '1 1 auto',
    overflowY: 'auto',
  },
  emptyPanelContainer: {
    flexDirection: 'column',
    flex: '1 1 auto',
    justifyContent: 'center',
    alignItems: 'center',
  },
  emptyPanelTextContainer: {
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
  emptyPanelTitle: {
    fontSize: '20px',
    m: '10px',
  },
  emptyPanelText: {
    fontSize: '14px',
    my: '10px',
  },
  emptyText: {
    textAlign: 'center',
  },
  carContainer: {
    flex: 1,
  },
  missingWorkshopOwnership: {
    mx: '15px',
    textAlign: 'center',
    mb: '5px',
  },
};
